import React from "react";
import axios from "axios";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import cors from "cors";
import { Provider } from "react-redux";
import { store, persistor } from "./store/Store";
import { PersistGate } from "redux-persist/integration/react";
import CurrencyProvider from './context/CurrencyContext';
import { OfflineProviderWrapper } from './offline/providers/OfflineProviderWrapper';
import { startLoading, stopLoading } from "./features/UISlice";

cors({
  origin: "http://localhost:3000",
  methods: ["GET", "POST", "PUT"],
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Only show global loader for vendor onboarding-related APIs
const isVendorOnboardingRequest = (config) => {
  try {
    const url = String(config?.url || "");
    // Whitelist of vendor onboarding endpoints (substring match)
    const allow = [
      "/vendor_registration",
      "/vendor_onboard_otp",
      "/vendor_onboard_resend_otp",
      "/vendor_verify_mail_otp",
      "/cheque_leaf_extract",
      "/extract_company_details",
      "/extract_mems_and_numbers",
      "/extract_pan_card_details",
      "/pan_authentication",
      "/gst_authentication",
      "/cin_authentication",
      "/msme_authentication",
      "/bank_authentication",
      "/check_pan_format",
      "/check_bank_format",
      "/manual_gst_check",
      "/manual_pan_check",
      "/manual_msme_check",
      "/manual_pan_msme_check",
      "/manual_bank_check",
      "/manual_pan_cin_check",
      "/manual_cin_check",
      "/gst_search_pan",
    ];
    return allow.some((p) => url.includes(p));
  } catch {
    return false;
  }
};

// Setup global axios interceptors (loader only for whitelisted requests)
axios.interceptors.request.use(
  (config) => {
    if (isVendorOnboardingRequest(config)) {
      store.dispatch(startLoading());
    }
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);
root.render(
  <React.StrictMode>
    <CurrencyProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <OfflineProviderWrapper>
            <App />
          </OfflineProviderWrapper>
        </PersistGate>
      </Provider>
    </CurrencyProvider>
  </React.StrictMode>
);

reportWebVitals();
